"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorOutline = void 0;
var react_1 = require("@emotion/react");
var buttonOutline = function (colors) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-color: ", ";\n  color: ", ";\n  background: transparent;\n\n  .loadingButtonIcon {\n    g,\n    rect {\n      fill: ", ";\n    }\n  }\n\n  .iconButton {\n    path,\n    g,\n    rect {\n      fill: ", ";\n    }\n  }\n\n  :hover {\n    background: ", ";\n    color: #fff;\n\n    .loadingButtonIcon g rect {\n      fill: #fff;\n    }\n\n    .iconButton {\n      path,\n      g,\n      rect {\n        fill: #fff;\n      }\n    }\n  }\n\n  :disabled {\n    background: transparent;\n    color: ", ";\n    border-color: ", ";\n\n    .loadingButtonIcon {\n      g,\n      rect {\n        fill: ", " !important;\n      }\n    }\n\n    .iconButton {\n      path,\n      g,\n      rect {\n        fill: ", ";\n      }\n    }\n  }\n"], ["\n  border-color: ", ";\n  color: ", ";\n  background: transparent;\n\n  .loadingButtonIcon {\n    g,\n    rect {\n      fill: ", ";\n    }\n  }\n\n  .iconButton {\n    path,\n    g,\n    rect {\n      fill: ", ";\n    }\n  }\n\n  :hover {\n    background: ", ";\n    color: #fff;\n\n    .loadingButtonIcon g rect {\n      fill: #fff;\n    }\n\n    .iconButton {\n      path,\n      g,\n      rect {\n        fill: #fff;\n      }\n    }\n  }\n\n  :disabled {\n    background: transparent;\n    color: ", ";\n    border-color: ", ";\n\n    .loadingButtonIcon {\n      g,\n      rect {\n        fill: ", " !important;\n      }\n    }\n\n    .iconButton {\n      path,\n      g,\n      rect {\n        fill: ", ";\n      }\n    }\n  }\n"])), colors.borderColor, colors.color, colors.borderColor, colors.borderColor, colors.borderColorHovered, colors.colorDisabled, colors.borderColorDisabled, colors.borderColor, colors.borderColor); };
var getColorOutline = function (color, theme) {
    var buttonColors;
    switch (color) {
        case 'secondary':
            buttonColors = {
                borderColor: theme.colors['secondary.400'],
                color: theme.colors['secondary.400'],
                borderColorHovered: theme.colors['secondary.400'],
                borderColorDisabled: theme.colors['secondary.100'],
                colorDisabled: theme.colors['secondary.200'],
            };
            break;
        case 'danger':
            buttonColors = {
                borderColor: theme.colors['red.400'],
                color: theme.colors['red.400'],
                borderColorHovered: theme.colors['red.400'],
                borderColorDisabled: theme.colors['red.100'],
                colorDisabled: theme.colors['red.200'],
            };
            break;
        case 'warning':
            buttonColors = {
                borderColor: theme.colors['yellow.400'],
                color: theme.colors['yellow.400'],
                borderColorHovered: theme.colors['yellow.500'],
                borderColorDisabled: theme.colors['yellow.200'],
                colorDisabled: theme.colors['yellow.200'],
            };
            break;
        case 'success':
            buttonColors = {
                borderColor: theme.colors['green.400'],
                color: theme.colors['green.400'],
                borderColorHovered: theme.colors['green.500'],
                borderColorDisabled: theme.colors['green.200'],
                colorDisabled: theme.colors['green.300'],
            };
            break;
        case 'black':
            buttonColors = {
                borderColor: theme.colors['black.400'],
                color: theme.colors['black.400'],
                borderColorHovered: theme.colors['black.500'],
                borderColorDisabled: theme.colors['black.300'],
                colorDisabled: theme.colors['black.300'],
            };
            break;
        case 'white':
            buttonColors = {
                borderColor: theme.colors['black.400'],
                color: theme.colors['black.500'],
                borderColorHovered: theme.colors['black.400'],
                borderColorDisabled: theme.colors['black.300'],
                colorDisabled: theme.colors['black.300'],
            };
            break;
        default:
            buttonColors = {
                borderColor: theme.colors['primary.400'],
                color: theme.colors['primary.400'],
                borderColorHovered: theme.colors['primary.400'],
                borderColorDisabled: theme.colors['primary.200'],
                colorDisabled: theme.colors['primary.200'],
            };
    }
    return buttonOutline(buttonColors);
};
exports.getColorOutline = getColorOutline;
var templateObject_1;
